module.exports = __webpack_public_path__ + "img/consultant_refuse.af23ce4d.png";